export default __webpack_public_path__ + "static/og_image-9bf6dd144c6b1666bf177efe92b7e926.png";